import { KpiValue } from './kpi-value'
import { KpiValueQuery } from './kpi-value-query'
import { KpiValueMutation } from './kpi-value-mutation'

export const entities = [KpiValue]
export const resolvers = [KpiValueQuery, KpiValueMutation]
export const subscribers = []
